import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/delivery.scss";

function Delivery() {
  return (
    <div className="delivery">
      <Header />
      <div className="customer-service-content col">
        <div className="customer-service-content-inner">
          <div className="customer-service-body">
            {/* dwMarker="content" dwContentID="9ecd81201ab796740ee8f32ada" */}
            <h2 className="customer-service-title">Shipping + Delivery</h2>
            <div className="cs-shipping-delivery">
              <section className="mb-4">
                <div className="row">
                  <div className="col-lg-8">
                    <h3>Shipping + Delivery</h3>
                    <p>
                      Shipping methods for your purchases are determined by the
                      types of items ordered. Smaller items tend to ship
                      Standard Delivery, some furniture ships with Threshold
                      Delivery, and the remainder ships with full-service
                      In-Home Delivery. If your order includes an item being
                      shipped via multiple methods, Standard charges for items
                      shipped outside the contiguous U.S. and Canada are
                      appended to any applicable Threshold or In-Home charges.
                      Your cart will reflect the delivery options available for
                      your order.
                    </p>
                    <p>&nbsp;</p>
                  </div>
                </div>
              </section>
              <section className="mb-5">
                <div className="row">
                  <div className="col-lg-8">
                    <p className="mb-2 font-sans-serif-bold">
                      Our shipping methods are:
                    </p>
                    <ul className="bulleted">
                      <li>
                        <span className="font-italic">Standard:</span> Smaller
                        items delivered Monday – Saturday, with select markets
                        delivered on Sunday. Typical delivery is 3-7 business
                        days from shipment date.
                      </li>
                      <li>
                        <span className="font-italic">Threshold:</span> Typical
                        delivery is 1–3 weeks from shipment date (within the
                        contiguous US). 4-hour delivery window. Furniture and
                        larger parcels will be delivered over your threshold.
                        Multi-unit building addresses will be left inside
                        building entrance, instead of your door. Please note,
                        scheduling options are subject to delivery location.
                        Excludes unpacking, assembly, and removal of packing
                        materials.
                      </li>
                      <li>
                        <span className="font-italic">In-home:</span> Typical
                        delivery takes 1–3 weeks from date of shipment within
                        the contiguous U.S. 4-hour delivery window. Furniture
                        ships with full-service in-home delivery, which includes
                        placement in your room of choice, assembly, and removal
                        of packaging. This delivery method does NOT include
                        mounting furniture to the walls, and/or installing any
                        electrical elements. Installation of wall anchoring /
                        anti-tip hardware is the responsibility of the customer.
                        Please note, scheduling options are subject to delivery
                        location.
                      </li>
                    </ul>
                  </div>
                </div>
              </section>
              <section className="mb-5">
                <div className="row">
                  <div className="col-lg-8">
                    <p className="mb-2 font-sans-serif-bold">
                      Shipping Details at a Glance
                    </p>
                    <ul className="bulleted">
                      <li>
                        Your cart will reflect the different shipping options
                        for each item.
                      </li>
                      <li>
                        We ship to the US, Canada, and Puerto Rico.
                        {/*, and the Virgin Islands.*/}
                      </li>
                      <li>
                        We can ship to a domestic freight forwarder of your
                        choosing for delivery overseas. Items delivered to a
                        freight forwarder need to be inspected prior to shipping
                        internationally. Please note we are unable to provide
                        return shipping or arrange pickups for international
                        freight forwarder shipments. If an item arrives damaged
                        or incorrect and was shipped internationally via freight
                        forwarding service, you will be responsible for
                        arranging and covering the cost of returning the product
                        to our facility in the United States. We cannot ship to
                        hotels, P.O. boxes or APO (Army Post Office), FPO (Fleet
                        Post Office) or DPO (Diplomatic Post Office)
                        destinations. Please email goods@denowl.shop for more
                        information.
                      </li>
                      <li>In-stock items ship within 1–5 business days.</li>
                      <li>
                        Smaller items tend to ship standard delivery, some
                        furniture ships with Threshold delivery, and the
                        remainder ships with full-service In-Home Delivery.
                      </li>
                      <li>
                        If your order includes an item being shipped via
                        multiple methods, standard delivery charges for items
                        shipped outside the contiguous U.S. and Canada are
                        appended to any applicable Threshold or In-Home charges.
                      </li>
                      <li>
                        For expedited delivery, contact your local Studio or
                        call 800.944.2233 prior to placing the order. Most
                        small-parcel in-stock items can be ordered with
                        Expedited Delivery at an additional cost. Some items may
                        be excluded due to size, weight or fragility. Orders
                        shipping to Alaska, Hawaii, Puerto Rico,
                        {/*the Virgin Islands,*/} or Canada also do not qualify.
                      </li>
                      <li>
                        An order is defined as one shipping method selected for
                        delivery to one address. Order value is calculated
                        before tax. For items that are on sale or discounted,
                        the order value is calculated using the original price.
                      </li>
                      <li>
                        We allow 10 calendar days for you to accept your order
                        without fees, after which you’ll begin to incur daily
                        storage fees of $10 per day, per order.
                      </li>
                      <li>
                        If no one is available at the time of the scheduled
                        delivery, a fee may apply for the unsuccessful delivery
                        attempt
                      </li>
                    </ul>
                  </div>
                </div>
              </section>
              <hr className="mb-4" />
              <section className="mb-7">
                <div className="row">
                  <div className="col-lg-12">
                    <h3>Delivery within the contiguous United States</h3>
                    <p className="mb-3">
                      If the delivery location is an island, there will be an
                      additional $299 charge to Threshold and In-Home
                      Deliveries.&nbsp;If delivery is to a remote location,
                      there will be an additional $299 charge to Threshold and
                      In-Home Deliveries.
                    </p>
                    <div className="table-responsive">
                      <div>&nbsp;</div>
                      <table className="table">
                        <thead>
                          <tr>
                            <th scope="col">Shipping Method</th>
                            <th scope="col">Rate</th>
                            <th scope="col">Max Charge</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Standard Delivery</td>
                            <td>
                              10% of order value, with a minimum fee of $19.99
                              (some exclusions apply)*
                              <br />
                              *Select office chairs ships for a flat rate fee of
                              $99 per item
                            </td>
                            <td>$399</td>
                          </tr>
                          <tr>
                            <td>Threshold Delivery</td>
                            <td>
                              15% of order value, with a minimum fee of $49
                            </td>
                            <td>$399</td>
                          </tr>
                          <tr>
                            <td>
                              In-Home Delivery within 100 miles of a Studio
                            </td>
                            <td>$399</td>
                            <td>$399</td>
                          </tr>
                          <tr>
                            <td>
                              In-Home Delivery more than 100 miles of a Studio
                            </td>
                            <td>$699</td>
                            <td>$699</td>
                          </tr>
                        </tbody>
                      </table>
                      <p>&nbsp;</p>
                    </div>
                  </div>
                </div>
              </section>
              <hr className="mb-4" />
              <section>
                <div className="row">
                  <div className="col-lg-12">
                    <h3>
                      Delivery to Alaska, Hawaii or Puerto Rico
                      {/*,or the Virgin Islands*/}
                    </h3>
                    {/*
<p class="mb-3">If the delivery location is an island, there will be an additional $150 charge to Threshold and In-Home Deliveries.&nbsp;If delivery is to a remote location, there will be an additional $100 charge to Threshold and In-Home Deliveries.</p>
*/}
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th scope="col">Shipping Method</th>
                            <th scope="col">Rate</th>
                            <th scope="col">Max Charge</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Standard Delivery</td>
                            <td>
                              15% of order value, with a minimum fee of $99
                            </td>
                            <td>$699</td>
                          </tr>
                          <tr>
                            <td>Threshold Delivery</td>
                            <td>
                              15% of order value, with a minimum fee of $299
                            </td>
                            <td>$999</td>
                          </tr>
                          <tr>
                            <td>In-Home Delivery, Local</td>
                            <td>$1,699</td>
                            <td>$1,699</td>
                          </tr>
                        </tbody>
                      </table>
                      <p>&nbsp;</p>
                      <h3>Delivery to Canada</h3>
                      <p className="mb-3">
                        If the delivery location is an island, there will be an
                        additional $299 charge to Threshold and In-Home
                        Deliveries.&nbsp;If delivery is to a remote location,
                        there will be an additional $299 charge to Threshold and
                        In-Home Deliveries.
                      </p>
                      <div className="table-responsive">
                        <div>&nbsp;</div>
                        <table className="table">
                          <thead>
                            <tr>
                              <th scope="col">Shipping Method</th>
                              <th scope="col">Rate</th>
                              <th scope="col">Max Charge</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>Standard Delivery</td>
                              <td>
                                10% of order value, with a minimum fee of $19.99
                                (some exclusions apply)*
                                <br />
                                *Select office chairs ships for a flat rate fee
                                of $99 per item
                              </td>
                              <td>$399</td>
                            </tr>
                            <tr>
                              <td>Threshold Delivery</td>
                              <td>
                                15% of order value, with a minimum fee of $49
                              </td>
                              <td>$399</td>
                            </tr>
                            <tr>
                              <td>
                                In-Home Delivery within 100 miles of a Studio
                              </td>
                              <td>$699</td>
                              <td>$699</td>
                            </tr>
                            <tr>
                              <td>
                                In-Home Delivery more than 100 miles of a Studio
                              </td>
                              <td>$799</td>
                              <td>$799</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            {/* END_dwmarker */}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Delivery;
